import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'NEW_PASSWORD_KEY',
    stateKey: 'password',
    isPassword: true,
    validateOnChange: true,
  },
  {
    gridXs: 12,
    label: 'CONFIRM_NEW_PASSWORD_KEY',
    stateKey: 'confirm_password',
    isPassword: true,
    validateOnChange: true,
  },
];

export default fields;
